<template>
  <div
    class="delModal"
    ref="delModal"
  >
    <a-modal
      v-model:visible="visible"
      title="删除"
      :closable="false"
      :centered="true"
      :getContainer="()=>$refs.delModal"
      @ok="handleOk"
      cancelText="取消"
      okText="确定"
    >
      <p>确认要删除吗？</p>
    </a-modal>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "delModal",
  data() {
    return {
      visible: false,
    }
  },
  methods: {
    show() {
      this.visible = true
    },
    hide() {
      this.visible = false
    },
    handleOk() {
      this.$emit('confirm')
      this.hide()
    }
  }
};
</script>
<style scoped>
.delModal :deep() .ant-modal-header {
  display: none;
}
.delModal :deep() .ant-modal-body {
  padding: 45px 30px 30px;
}
.delModal :deep() .ant-modal-footer {
  border: 0;
}
.delModal :deep() .ant-btn:nth-child(1) {
  width: 110px;
  height: 40px;
  color: #0088ff;
  border: 1px solid #0088ff;
  border-radius: 6px;
}
.delModal :deep() .ant-btn-primary {
  width: 110px;
  height: 40px;
  margin: 10px 0 10px 20px;
  background: linear-gradient(-30deg, #0077ee, #33aaff);
  border-radius: 6px;
}
</style>
